"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateDownloadButton = void 0;
const react_1 = __importDefault(require("react"));
const react_components_1 = require("@cimpress/react-components");
const file_saver_1 = require("file-saver");
const i18n_1 = require("../i18n");
const useMaterialization_1 = require("../hooks/useMaterialization");
exports.TemplateDownloadButton = (_a) => {
    var { enforceHtmlProcessor, enforcePdfOutput, accessToken, templateUrl, crawlingOptions, language, fileName, payload, onError, onClick, buttonContent, loadingButtonContent } = _a, rest = __rest(_a, ["enforceHtmlProcessor", "enforcePdfOutput", "accessToken", "templateUrl", "crawlingOptions", "language", "fileName", "payload", "onError", "onClick", "buttonContent", "loadingButtonContent"]);
    const { materializationBlob, fetchingError, fetching, contentType } = useMaterialization_1.materialize(enforceHtmlProcessor, enforcePdfOutput, accessToken, templateUrl, payload, crawlingOptions);
    const t = i18n_1.getI18nInstance().getFixedT(language);
    if (fetchingError && onError) {
        onError(fetchingError);
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_components_1.Button, Object.assign({}, rest, { disabled: fetching || fetchingError, onClick: (e) => {
                onClick && onClick(e);
                const blobData = new Blob([materializationBlob], {
                    type: contentType
                });
                file_saver_1.saveAs(blobData, fileName || 'output');
            } }), fetching
            ? loadingButtonContent || t('loading')
            : buttonContent || t('download')));
};
//# sourceMappingURL=TemplateDownloadButton.js.map